// Stylesheets
import './assets/scss/site.scss';

import { trigger } from './assets/modules/trigger';
import { hover } from './assets/modules/hover';
import { modal } from './assets/modules/modal';
import { gallery } from './assets/modules/gallery';
import { sameHeight } from './assets/modules/sameHeight';
import { floatingBox } from './assets/modules/floatingBox';

const init = () => {
  trigger();
  hover();
  modal();
  gallery();
  sameHeight();
  floatingBox();
  document.body.classList.add('is-init')
}

init();